/* Reader kiwi variant — holding and reading an open book. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderReader(p: KiwiPalette) {
  return (
    <>
      {/* Body */}
      <path d="M12 6H20V8H24V10H26V18H24V22H20V24H12V22H8V18H6V10H8V8H12V6Z" fill={p.body} />

      {/* Highlight */}
      <rect x="20" y="10" width="2" height="2" fill={p.highlight} opacity={0.3} />

      {/* Tuft */}
      <path d="M10 4H12V6H10V4ZM12 2H14V4H12V2Z" fill={p.body} />

      {/* Beak */}
      <path d="M4 12H6V14H4V12ZM2 14H4V16H2V14ZM2 16H4V18H2V16ZM4 18H6V20H4V18Z" fill={p.beak} />

      {/* Eye — pupil looks down at book */}
      <rect x="10" y="10" width="6" height="6" fill={p.eyeBg} />
      <rect x="12" y="13" width="2" height="2" fill={p.pupil} />

      {/* Open book held in front */}
      {/* Left page */}
      <rect x="7" y="20" width="8" height="8" fill={p.eyeBg} />
      {/* Right page */}
      <rect x="17" y="20" width="8" height="8" fill={p.eyeBg} />
      {/* Book spine */}
      <rect x="15" y="19" width="2" height="10" fill={p.accent} opacity={0.35} />
      {/* Text lines — left page */}
      <rect x="8" y="21" width="6" height="1" fill={p.pupil} opacity={0.15} />
      <rect x="8" y="23" width="5" height="1" fill={p.pupil} opacity={0.12} />
      <rect x="8" y="25" width="6" height="1" fill={p.pupil} opacity={0.15} />
      {/* Text lines — right page */}
      <rect x="18" y="21" width="6" height="1" fill={p.pupil} opacity={0.15} />
      <rect x="18" y="23" width="5" height="1" fill={p.pupil} opacity={0.12} />
      <rect x="18" y="25" width="6" height="1" fill={p.pupil} opacity={0.15} />
    </>
  );
}
